import React, { Component } from "react";
import { Table, Pagination, Col, Row, Button, Select, Input } from "antd";
import moment from "moment";
import { strings } from "../../../helpers";

const { Option } = Select;
const { Search } = Input;
const searchOptions = {
  componentRestrictions: { country: "in" }
};

export default class BankDetailsView extends Component {
  render() {
    const { details } = this.props;

    const columns = [
      {
        title: "Account Number",
        dataIndex: "account_no",
        key: "account_no",
        align: "left"
      },
      {
        title: "Account Name",
        key: "account_name",
        align: "left",
        dataIndex: "account_name",
      },
      {
        title: "Bank Name",
        dataIndex: "bank_name",
        key: "bank_name",
        align: "left"
      },
      {
        title: "IFSC Code",
        dataIndex: "ifsc_code",
        key: "ifsc_code",
        align: "left"
      }
    ];
    let source = [];
    if (details && details.bank_details) {
      source = details.bank_details;
    }

    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              Bank Details
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              columns={columns}
              dataSource={source}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
      </div>
    );
  }
}
